

















































import Vue from "vue";

import { Cells } from "@/components/organisms/Table/blocks/RowPicker/blocks";
import { CartAdd, OneClick } from "@/components/icons";
import { personalModule } from "@/plugins/store-accessors";
import { getTooltips } from "@/components/organisms/Table/blocks/RowPicker/utils";

export default Vue.extend({
  name: "Controls",
  props: {
    quantity: { type: Number, default: 1 },
    isInCart: { type: Boolean, default: false },
    item: { type: Object, default: () => ({}) },
    addToCart: { type: Function, default: () => null },
    fastOrder: { type: Function, default: () => null },
    onQuantityChange: { type: Function, default: () => null },
  },
  components: {
    ActionQuantity: Cells.ActionQuantity,
    CartAdd,
    OneClick,
  },
  computed: {
    isAuthorized() {
      return personalModule.isAuthorized;
    },
    maxCount() {
      return this.item.onSale ? this.item.stock : null;
    },
    tooltips() {
      const tooltip = getTooltips(this.item);
      return tooltip;
    },
  },
});
